/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
/*<div class="konfig-result">
         <a href="{{ all_products['sattel-test'].url }}" id="konfiglink">  
        	<img id="konfigimg" src="https://cdn.shopify.com/s/files/1/0517/3814/9058/{{ all_products['sattel-test'].featured_image }}" alt="{{ all_products["sattel-test"].title }}"> 
        	<h2 id="konfigtitle">{{ all_products["sattel-test"].title }}</h2>
          	<p id="konfigp">{{ all_products["sattel-test"].content }}</p>
         </a>
        </div>*/
// Insert any custom theme js here...

jQuery(function ($) {
    $('.parent').click(function () {
        $(this).children('.dropdown-menu').addClass('show');
    }, function () {
        $(this).children('.dropdown-menu').removeClass('show');
    });
});
jQuery(function ($) {
    $(".dropdown-toggle").hover(function () {
        $(this).attr("data-toggle", "dropdown");
    });
});

let idData;
let theID;
function tzMann(){
  const thisurl = window.location.href;
  const tArea = document.getElementById("CartSpecialInstructions");
  if(thisurl.includes("#tzid")){
    //console.log("ist drin");
    //console.log("Direkt Log: " + thisurl.split('#tzid=')[1]);
    theID = thisurl.split('#tzid=')[1];
    // Save data to sessionStorage
    sessionStorage.setItem("tzid", theID);
    // Get saved data from sessionStorage
    idData = sessionStorage.getItem("tzid");

    //console.log("Session Log: " + idData);
  }else{
    //console.log("ist nicht drin.");
    //console.log("Ist immer noch da: " + sessionStorage.getItem("tzid"));
  }
  if(tArea && sessionStorage.getItem("tzid")){
    tArea.value = "Mein TZMann Code: " + sessionStorage.getItem("tzid");
  }
}
window.addEventListener("load", tzMann);

let root = document.documentElement;


function fullWidthMargin() {
    //var ref = document.getElementById("MainContent").offsetWidth;
    var ref = document.querySelector("body").offsetWidth;
    var pw = document.querySelector(".page-width");

    var styles = parseInt(window.getComputedStyle(pw).getPropertyValue("width"));


    var fwMargin = (ref - styles) / 2 + "px";

    root.style.setProperty('--fullmargin', fwMargin);
}

window.addEventListener("load", fullWidthMargin);
window.addEventListener("resize", fullWidthMargin);
/*
function navHeight() {
    var theHeight = document.getElementById("header-desktop").offsetHeight + "px";
    root.style.setProperty('--navheight', theHeight);
}
window.addEventListener("load", navHeight);
window.addEventListener("resize", navHeight);


function mobileNavi() {
    var ref = document.getElementById("headermobile");
    var navi = document.querySelector(".header");

    var naviStyles = window.getComputedStyle(navi);
    var naviPos = naviStyles.getPropertyValue('position');

    var scrolledY = window.scrollY;
    if (ref.offsetHeight > 0) {
        if (scrolledY >= ref.offsetHeight) {
            if (naviPos == "relative") {
                navi.style.position = "fixed";
            }
        } else {
            if (naviPos == "fixed") {
                navi.style.position = "relative";
            }
        }
    } else {
        navi.style.position = "fixed";
    }

}

window.addEventListener("load", mobileNavi);
window.addEventListener("resize", mobileNavi);
window.addEventListener("scroll", mobileNavi);

*/


function getOwls() {
    var owls = document.querySelectorAll(".owl-carousel");
    if (owls) {
        owls.forEach(function (owl) {
            if (!(owl.classList.contains("blog_owl"))) {
                var theID = '#' + owl.id;
                $(theID).owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    items: 1,
                    dots: true,
                    dotsEach: 1,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    responsive: {
                        750: {
                            items: 2
                        },
                        991: {
                            items: 3
                        }
                    }
                })
            } else {
                var theID = '#' + owl.id;
                $(theID).owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    items: 1,
                    dots: true,
                    dotsEach: 1,
                    autoplay: true,
                    autoplayTimeout: 3000,
                    autoplayHoverPause: true,
                    responsive: {
                        750: {
                            items: 2
                        }
                    }
                })
            }
        });
    }
}

window.addEventListener("load", getOwls);
